import { View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMBarChartCard,
  PMDonutChartCard,
} from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { DONUT_CARD_LAYOUT } from "../../../constants";
import {
  getAllReportingItems,
  getArrayFieldData,
  withTotalInTitle,
} from "../get-dashboard-chart-data";

/**
 * Adds the "systems per technical exposure" bar and donut chart cards, in
 * that order (#2222).
 */
export function addTechnicalExposureDashboardCards(
  view: View<TestAppState, DragAndDropLayout>
) {
  const technicalExposureBarChartComponent = view.addComponent({
    component: PMBarChartCard,
    layoutProps: {
      componentId: "technicalExposureDashboardBarChartComponent",
      labels: ["barChart", "chart", "technicalExposure"],
      description:
        "Shows systems grouped by technical exposure across all projects.",
      title: "Systems per Technical Exposure",
    },
  });

  technicalExposureBarChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.technicalExposure
    );

    return {
      title: "Systems per Technical Exposure",
      categories: entries.map((entry) => entry.label),
      data: entries.map((entry) => entry.count),
      chartType: 1 as const,
      xLabel: "Systems",
      yLabel: "Technical Exposure",
      colors: entries.map((entry) => entry.color),
      fixedHeight: "320px",
    };
  });

  const technicalExposureDonutChartComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "technicalExposureDashboardDonutChartComponent",
      labels: ["donutChart", "chart", "technicalExposure"],
      description:
        "Shows systems grouped by technical exposure across all projects.",
      title: "Systems per Technical Exposure",
    },
  });

  technicalExposureDonutChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.technicalExposure
    );

    return {
      title: withTotalInTitle(
        "Systems per Technical Exposure",
        allItems.length
      ),
      icon: "DonutLarge",
      ...DONUT_CARD_LAYOUT,
      data: entries.map((entry) => ({
        label: entry.label,
        value: entry.count,
        color: entry.color,
      })),
    };
  });
}
